import type { IH5PEditorState } from './types';

import { EditorModes } from './types';
import * as ActionTypes from './action-types';

export const initialState: IH5PEditorState = {
  showEditor: false,
  contentId: undefined,
  loading: false,
  saving: false,
  content: undefined,
  contentHash: undefined,
  lastSavedContentHash: undefined,
  mode: EditorModes.edit,
};

type Action = {
  type: string;
  payload?: any;
};

export default function h5pEditorReducer(
  state: IH5PEditorState = initialState,
  action: Action
): IH5PEditorState {
  switch (action.type) {
    case ActionTypes.H5PEDITOR_OPEN:
      return {
        ...state,
        showEditor: false,
        contentId: action.payload.contentId,
        loading: true,
        saving: false,
        mode: EditorModes.edit,
        content: undefined,
        contentHash: undefined,
        lastSavedContentHash: undefined,
      };

    case ActionTypes.H5PEDITOR_SETSHOWEXPORTDIALOG:
      return {
        ...state,
        showExportDialog: action.payload.showExportDialog,
      };

    case ActionTypes.H5P_EXPORT_FAILURE:
      return {
        ...state,
        exportLoading: false,
        exportProgress: 0,
      };

    case ActionTypes.H5P_EXPORT_SUCCESS:
      return {
        ...state,
        exportLoading: false,
        exportProgress: 100,
        downloadUrl: action.payload.downloadUrl,
      };

    case ActionTypes.H5P_EXPORT_UPDATE:
      return {
        ...state,
        exportProgress: action.payload.progress,
      };

    case ActionTypes.H5P_EXPORT_REQUEST:
      return {
        ...state,
        showExportDialog: true,
        exportLoading: true,
        exportProgress: 0,
        downloadUrl: undefined,
      };

    case ActionTypes.H5PEDITOR_CHANGEMODE:
      return {
        ...state,
        mode: action.payload.mode,
      };

    case ActionTypes.H5PEDITOR_SETCONTENTPARAMS:
      return {
        ...state,
        content: action.payload.params,
        contentHash: action.payload.contentHash,
      };

    case ActionTypes.H5PEDITOR_UPDATEEDITORCONTENT_REQUEST:
      return {
        ...state,
        saving: true,
      };

    case ActionTypes.H5PEDITOR_UPDATEEDITORCONTENT_SUCCESS:
      return {
        ...state,
        saving: false,
        lastSavedContentHash: action.payload.lastSavedContentHash,
        contentId: action.payload.contentId,
      };

    case ActionTypes.H5PEDITOR_LOADEDITORCONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        content: action.payload.content,
        lastSavedContentHash: action.payload.contentHash,
        contentHash: action.payload.contentHash,
      };

    case ActionTypes.H5PEDITOR_CLOSE:
      return {
        ...state,
        showEditor: false,
        contentId: undefined,
        loading: false,
        saving: false,
        content: undefined,
        contentHash: undefined,
      };

    default:
      return state;
  }
}
